import * as yup from 'yup';

import {GendersEnum} from '@/constants';

import {TFunction} from 'i18next';
import {locationShape} from '@/schemas/sub-schemas';

export const NAME_MAX_LENGTH = 50;
const NAME_MIN_LENGTH = 2;

export const DESC_MAX_LENGTH = 1000;

const UserValidationSchema = (t: TFunction) =>
  yup.object({
    name: yup
      .string()
      .min(
        NAME_MIN_LENGTH,
        t('validation:min_length', {
          name: t('name'),
          min: NAME_MIN_LENGTH
        }) || undefined
      )
      .max(
        NAME_MAX_LENGTH,
        t('validation:max_length', {
          name: t('name'),
          max: NAME_MAX_LENGTH
        }) || undefined
      )
      .required(
        t('validation:is_required', {
          name: t('name')
        }) || undefined
      ),
    description: yup.string().max(
      DESC_MAX_LENGTH,
      t('validation:max_length', {
        name: t('description'),
        max: DESC_MAX_LENGTH
      }) || undefined
    ),
    birthday: yup
      .date()
      .required(
        t('validation:is_required', {
          name: t('birthday')
        }) || undefined
      )
      .max(
        new Date(new Date().setFullYear(new Date().getFullYear() - 16)),
        t('validation:min_age', {age: 16}) || undefined
      )
      .min(
        new Date(new Date().setFullYear(new Date().getFullYear() - 99)),
        t('validation:max_age', {age: 99}) || undefined
      ),
    gender: yup.string().oneOf(Object.values(GendersEnum)),
    location: locationShape({t, name: t('location')}).nullable()
  });

export type UserSchemaData = yup.InferType<
  ReturnType<typeof UserValidationSchema>
>;

export default UserValidationSchema;
